export var PollData_Poll_Settings_Permissions_ViewRole;
(function (PollData_Poll_Settings_Permissions_ViewRole) {
    /** CREATOR - Only Poll creator can view the results */
    PollData_Poll_Settings_Permissions_ViewRole["CREATOR"] = "CREATOR";
    /** VOTERS - Anyone who voted can see the results */
    PollData_Poll_Settings_Permissions_ViewRole["VOTERS"] = "VOTERS";
    /** EVERYONE - Anyone can see the results, even if one didn't vote */
    PollData_Poll_Settings_Permissions_ViewRole["EVERYONE"] = "EVERYONE";
    PollData_Poll_Settings_Permissions_ViewRole["UNRECOGNIZED"] = "UNRECOGNIZED";
})(PollData_Poll_Settings_Permissions_ViewRole || (PollData_Poll_Settings_Permissions_ViewRole = {}));
export var PollData_Poll_Settings_Permissions_VoteRole;
(function (PollData_Poll_Settings_Permissions_VoteRole) {
    /** SITE_MEMBERS - Logged in member */
    PollData_Poll_Settings_Permissions_VoteRole["SITE_MEMBERS"] = "SITE_MEMBERS";
    /** ALL - Anyone */
    PollData_Poll_Settings_Permissions_VoteRole["ALL"] = "ALL";
    PollData_Poll_Settings_Permissions_VoteRole["UNRECOGNIZED"] = "UNRECOGNIZED";
})(PollData_Poll_Settings_Permissions_VoteRole || (PollData_Poll_Settings_Permissions_VoteRole = {}));
export var PollData_Layout_PollLayout_Type;
(function (PollData_Layout_PollLayout_Type) {
    /** LIST - List */
    PollData_Layout_PollLayout_Type["LIST"] = "LIST";
    /** GRID - Grid */
    PollData_Layout_PollLayout_Type["GRID"] = "GRID";
    PollData_Layout_PollLayout_Type["UNRECOGNIZED"] = "UNRECOGNIZED";
})(PollData_Layout_PollLayout_Type || (PollData_Layout_PollLayout_Type = {}));
export var PollData_Layout_PollLayout_Direction;
(function (PollData_Layout_PollLayout_Direction) {
    /** LTR - Left-to-right */
    PollData_Layout_PollLayout_Direction["LTR"] = "LTR";
    /** RTL - Right-to-left */
    PollData_Layout_PollLayout_Direction["RTL"] = "RTL";
    PollData_Layout_PollLayout_Direction["UNRECOGNIZED"] = "UNRECOGNIZED";
})(PollData_Layout_PollLayout_Direction || (PollData_Layout_PollLayout_Direction = {}));
export var PollData_Design_PollDesign_Background_Type;
(function (PollData_Design_PollDesign_Background_Type) {
    /** COLOR - Color background type */
    PollData_Design_PollDesign_Background_Type["COLOR"] = "COLOR";
    /** IMAGE - Image background type */
    PollData_Design_PollDesign_Background_Type["IMAGE"] = "IMAGE";
    /** GRADIENT - Gradiant background type */
    PollData_Design_PollDesign_Background_Type["GRADIENT"] = "GRADIENT";
    PollData_Design_PollDesign_Background_Type["UNRECOGNIZED"] = "UNRECOGNIZED";
})(PollData_Design_PollDesign_Background_Type || (PollData_Design_PollDesign_Background_Type = {}));
//# sourceMappingURL=plugin_poll.enums.js.map